import { useFormContext } from "react-hook-form";
import Select, { ClassNamesConfig, GroupBase } from "react-select";

import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { createClassNames } from "@/components/ui/react-select";
import {
  CreateBreakoutSessionsFormData,
  ParticipantOptionData,
} from "@/features/breakout-sessions/types/create-breakout-sessions.schema";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

type BreakoutSessionElementProps = {
  index: number;
};

export const BreakoutSessionElement = (props: BreakoutSessionElementProps) => {
  const { index } = props;
  const form = useFormContext<CreateBreakoutSessionsFormData>();
  const participants = useVidyoStore(
    (state) => state.participants.participants,
  );
  const reactSelectClassNames = createClassNames({});
  const placedParticipants = form.watch(`breakoutSessions`);

  const flatPlacedParticipants: string[] = placedParticipants.flatMap(
    (session) => session.participants.map((p) => p.participantId),
  );

  const notPlacedParticipants: ParticipantOptionData[] = participants
    .filter(
      (participant) =>
        !flatPlacedParticipants.some(
          (placedParticipant) =>
            placedParticipant === participant.participantId,
        ),
    )
    .map((p) => ({
      participantId: p.participantId,
      entityId: p.entityId,
      name: p.name,
    }));

  return (
    <div className="space-y-4 rounded-md border border-border p-4">
      <div className="flex items-center gap-2">
        <FormField
          control={form.control}
          name={`breakoutSessions.${index}.name`}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input disabled={form.formState.isSubmitting} {...field} />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name={`breakoutSessions.${index}.participants`}
          render={({ field }) => (
            <p className="ml-auto text-sm text-muted">{field.value.length}</p>
          )}
        />
      </div>
      <FormField
        control={form.control}
        name={`breakoutSessions.${index}.participants`}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Select
                placeholder="Start typing a name"
                isMulti
                unstyled
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.participantId}
                options={notPlacedParticipants}
                components={{
                  ClearIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                classNames={
                  reactSelectClassNames as ClassNamesConfig<
                    ParticipantOptionData,
                    true,
                    GroupBase<ParticipantOptionData>
                  >
                }
                noOptionsMessage={() => "No participants found"}
                isDisabled={form.formState.isSubmitting}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
